// extracted by mini-css-extract-plugin
module.exports = {"root":"Plug_root__j6WZ8","SC__debug":"Plug_SC__debug__lLXic"};